module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_vm._m(0), _c('main', _vm._l(([1, 2, 3]), function(j) {
    return _c('div', {
      staticClass: "row center-xs"
    }, _vm._l(([1, 2, 3, 4]), function(i) {
      return _c('div', {
        staticClass: "col-xs-12 col-sm-6 col-md-3 cardholder"
      }, [_c('router-link', {
        attrs: {
          "to": "/game"
        }
      }, [_c('div', {
        staticClass: "card"
      }, [_c('header', [_c('svg', {
        attrs: {
          "viewBox": "0 0 32 32"
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.757 19.868c-0.416 0-0.832-0.159-1.149-0.476-2.973-2.973-2.973-7.81 0-10.783l6-6c1.44-1.44 3.355-2.233 5.392-2.233s3.951 0.793 5.392 2.233c2.973 2.973 2.973 7.81 0 10.783l-2.743 2.743c-0.635 0.635-1.663 0.635-2.298 0s-0.635-1.663 0-2.298l2.743-2.743c1.706-1.706 1.706-4.481 0-6.187-0.826-0.826-1.925-1.281-3.094-1.281s-2.267 0.455-3.094 1.281l-6 6c-1.706 1.706-1.706 4.481 0 6.187 0.635 0.635 0.635 1.663 0 2.298-0.317 0.317-0.733 0.476-1.149 0.476z"
        }
      }), _c('path', {
        attrs: {
          "d": "M8 31.625c-2.037 0-3.952-0.793-5.392-2.233-2.973-2.973-2.973-7.81 0-10.783l2.743-2.743c0.635-0.635 1.664-0.635 2.298 0s0.635 1.663 0 2.298l-2.743 2.743c-1.706 1.706-1.706 4.481 0 6.187 0.826 0.826 1.925 1.281 3.094 1.281s2.267-0.455 3.094-1.281l6-6c1.706-1.706 1.706-4.481 0-6.187-0.635-0.635-0.635-1.663 0-2.298s1.663-0.635 2.298 0c2.973 2.973 2.973 7.81 0 10.783l-6 6c-1.44 1.44-3.355 2.233-5.392 2.233z"
        }
      })])]), _c('div', {
        staticClass: "info"
      }, [_c('b', [_vm._v("The Breakout Game")]), _c('p', [_vm._v("Create your very own breakout game from scratch!")])])])])], 1)
    }))
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header-overlay"
  }), _c('div', {
    staticClass: "header-text"
  }, [_c('h1', [_vm._v("#CODE4ALL")]), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png"
    }
  }), _c('h2', [_vm._v("เล่นเกมมาเยอะแล้ว มาสร้างเองบ้างสิ!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3b6318"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Landing.vue
// module id = 87
// module chunks = 2